<template>
  <div class="excel-upload">
    <div class="hide">
      <input
        ref="fileupload"
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        type="file"
        @change="handleFileUpload"
        :name="name"
      />
    </div>
    <div class="flex ai-center">
      <div class="excel-upload-text" @click="open">
        <span v-if="currentFile" class="excel-upload-name"> {{currentFile.name | overflowText}}</span>
        <span v-else class="excel-upload-placeholder" ref="placeholder">{{ name }}</span>  
      </div>
      <button v-if="currentFile" class="btn btn-sm btn-info" @click="upload">Отправить</button>
      <button v-else class="btn btn-sm btn-info" @click="open">Загрузить Excel</button>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { errorNotify } from "@/plugins/functions";

export default {
  data: () => ({
    currentFile: null,
  }),
  props: {
    url: {
      default: "",
    },
    name: {
      default: "",
    },
    getList: {
      default: function () {
        return false;
      },
    },
  },
  created() {},
  filters:{
    overflowText(text){
      let newText = text;
      if(text.length > 20){
        newText = `
        ${text.slice(0, 7)}
        ...
        ${text.slice(text.length-7, text.length)}
        `
      }
      return newText
    },
  },
  methods: {
    clear(){
      this.currentFile = null
      this.$refs.fileupload.value = null
    },
    open(){
      this.$refs.fileupload.click()
    },
    async upload(){
      if(!this.currentFile)
        return
      let bodyFormData = new FormData();
      bodyFormData.append(`file`, this.currentFile);
      this.currentFile = null
      this.$refs.fileupload.value = null
      this.$http
        ({
          url: this.url,
          // url: "osycle",
          // method: 'method',
          method: 'POST',
          data: bodyFormData,
          headers: {
            "Content-Type": "multipart/form-data",
            // "Accept": "application/json",
            // "api-version": "1",
            // "platform": "web"
          }
        })
        .then((response) => {
          this.$notify({
            title: "Данные",
            message: "Данные успешно загрузились",
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
          this.getList()
          return response.data.data;
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
          return null;
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
          }, 400);
        });
    },
    async handleFileUpload(event) {
      if (event.target.files && event.target.files.length > 0) {
        const file = event.target.files[0];
        const reader = new FileReader();
        // let testName = new RegExp(`^${this.name}[ ()0-9-]*?\.`, 'gim').test(file.name)
        // if(!testName){
        //   this.currentFile = null
        //   this.$refs.fileupload.value = null
        //   this.$refs.placeholder.style.opacity = 1
        //   setTimeout(() => {
        //     this.$refs.placeholder.style.opacity = ""
        //   }, 800);
        //   return
        // }
        reader.readAsDataURL(file);
        await reader.addEventListener("load", (e) => {});
        this.currentFile = event.target.files[0]
      }else{
        this.currentFile = null
        this.$refs.fileupload.value = null
      }
    },
  },
};
</script>

<style lang="scss">
  .excel-upload{
    &-placeholder{
      position: absolute;
      left: 15px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 12px;
      opacity: 0.3;
      width: calc(100% - 30px);
    }
    &-text{
      position: relative;
      display: flex;
      align-items: center;
      background-color: #f3f3f3;
      width: 135px;
      padding: 5px 15px;
      border-radius: 5px;
      height: 33px;
      font-size: 12px;
      overflow: hidden;
      margin-right: -4px;
      &:hover{
        cursor: pointer;
      }
      @media (max-width: 768px){
        width: 85px 
      }
    }
    &-name, &-placeholder{
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      transition: opacity 0.2s ease;
    }
    .btn{
      z-index: 1;
    }
    @media (min-width: 991px){
      .btn-info{
        border-color: #545454;
        background-color: #545454;
        // width: 105px;
      }
    }
  }
</style>
